import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IProductListCollectionSelectedWebScreen_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductListCollectionSelectedWebScreen_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  B2BGetUserId: any[];
  B2BGetUserId_dummy: any[];
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  B2BListProductCollectionSelected: any[];
  B2BListProductCollectionSelected_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  SetFocusTo: any;
  SetFocusTo_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  B2BAddFavorite: number;
  B2BAddFavorite_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  B2BRemoveFavorite: number;
  B2BRemoveFavorite_dummy: number;
  isComp581739Visible: "visible" | "hidden";
  isComp791652Visible: "visible" | "hidden";
}

export class ProductListCollectionSelectedWebScreen_ScreenBase extends React.PureComponent<
  IProductListCollectionSelectedWebScreen_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  productlistcollectionselectedwebscreen_791825_value_kuikaGalleryViewRef: React.RefObject<any>;
  productlistcollectionselectedwebscreen_818753_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 810087,
          PropertyName: "placeholder",
          Value: "Koleksiyon Ara",
          TagName: "TextInput2_placeholder",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 810087,
          PropertyName: "placeholder",
          Value: "Search Collection",
          TagName: "TextInput2_placeholder",
        },
      ],
    },
    {
      Id: "dbf9998c-77da-4edf-9344-2795b9174ae5",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 810087, PropertyName: "placeholder", Value: "Yan Doldurma Ara" },
        {
          Id: 791825,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productlistcollectionselectedwebscreen_810087_value_kuikaTextInputRef =
      React.createRef();
    this.productlistcollectionselectedwebscreen_791825_value_kuikaGalleryViewRef =
      React.createRef();
    this.productlistcollectionselectedwebscreen_818753_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      B2BGetUserId: [],
      B2BGetRolesById: [],
      B2BListProductCollectionSelected: [],
      SetValueOf: "",
      SetFocusTo: "",
      NAVIGATE: "",
      B2BAddFavorite: 0,
      TriggerEvent: "",
      B2BRemoveFavorite: 0,
      isComp581739Visible: "hidden",
      isComp791652Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productlistcollectionselectedwebscreen",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProductListCollectionSelectedWebScreenPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ProductListCollectionSelectedWebScreenPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productlistcollectionselectedwebscreen",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productlistcollectionselectedwebscreen",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProductListCollectionSelectedWebScreenPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProductListCollectionSelectedWebScreenPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProductListCollectionSelectedWebScreenPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      PageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      UserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      filtre_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageSize_2: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListCollectionSelectedWebScreen/ProductListCollectionSelectedWebScreenPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetUserId = result?.data.b2BGetUserId;
    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    stateVars.B2BListProductCollectionSelected =
      result?.data.b2BListProductCollectionSelected;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListCollectionSelectedWebScreenPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListCollectionSelectedWebScreenPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_791825 =
      stateVars.B2BListProductCollectionSelected ??
      this.state.B2BListProductCollectionSelected;
    stateVars.isComp581739Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "isFavorite"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp791652Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "isFavorite"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productlistcollectionselectedwebscreen_818753_total =
      ReactSystemFunctions.value(
        this,
        stateVars.B2BListProductCollectionSelected !== undefined
          ? stateVars.B2BListProductCollectionSelected?.length > 0
            ? stateVars.B2BListProductCollectionSelected[0].totalRowCount
            : null
          : this.state.B2BListProductCollectionSelected?.length > 0
          ? this.state.B2BListProductCollectionSelected[0].totalRowCount
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProductListCollectionSelectedWebScreenComponent_925316_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListCollectionSelectedWebScreen/ProductListCollectionSelectedWebScreenComponent_925316_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BListProductCollectionSelected =
      result?.data.b2BListProductCollectionSelected;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListCollectionSelectedWebScreenComponent_925316_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListCollectionSelectedWebScreenComponent_925316_onClick1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "productlistcollectionselectedwebscreen_818753_value",
          "string"
        ),
        1,
        ReactSystemFunctions.convertToTypeByName("current", "string"),
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductListCollectionSelectedWebScreenComponent_925316_onClick2_();
          resolve();
        });
      });

      return isErrorOccurred;
    };
  ProductListCollectionSelectedWebScreenComponent_925316_onClick2_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }
      if (
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            ReactSystemFunctions.value(
              this,
              "productlistcollectionselectedwebscreen_810087_value",
              "value",
              "",
              "",
              ""
            )
          ),
          ""
        )
      ) {
        stateVars.SetFocusTo = await ReactSystemFunctions.setFocusTo(
          ReactSystemFunctions.convertToTypeByName("810087", "string")
        );

        this.props.form?.setFieldsValue(formVars);

        await new Promise((resolve, reject) => {
          this.setState(stateVars, async () => {
            isErrorOccurred =
              await this.ProductListCollectionSelectedWebScreenComponent_925316_onClick3_();
            resolve();
          });
        });
      } else {
        await new Promise((resolve, reject) => {
          this.setState(stateVars, async () => {
            isErrorOccurred =
              await this.ProductListCollectionSelectedWebScreenComponent_925316_onClick3_();
            resolve();
          });
        });
      }

      return isErrorOccurred;
    };
  ProductListCollectionSelectedWebScreenComponent_925316_onClick3_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      stateVars.dataSource_791825 =
        stateVars.B2BListProductCollectionSelected ??
        this.state.B2BListProductCollectionSelected;
      formVars.productlistcollectionselectedwebscreen_818753_total =
        ReactSystemFunctions.value(
          this,
          stateVars.B2BListProductCollectionSelected !== undefined
            ? stateVars.B2BListProductCollectionSelected?.length > 0
              ? stateVars.B2BListProductCollectionSelected[0].totalRowCount
              : null
            : this.state.B2BListProductCollectionSelected?.length > 0
            ? this.state.B2BListProductCollectionSelected[0].totalRowCount
            : null
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  ProductListCollectionSelectedWebScreenComponent_515292_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/productlistdesignweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ProductListDesignWeb",
      "ProductAttribute02",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "productAttribute02"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductListCollectionSelectedWebScreen",
      "ProductListDesignWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListCollectionSelectedWebScreenComponent_581739_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "productAttribute02"
        ),
        "string"
      ),
      ProductAttribute02Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "productAttribute02Description"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListCollectionSelectedWebScreen/ProductListCollectionSelectedWebScreenComponent_581739_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BAddFavorite = result?.data.b2BAddFavorite;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListCollectionSelectedWebScreenComponent_581739_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListCollectionSelectedWebScreenComponent_581739_onClick1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      await this.ProductListCollectionSelectedWebScreenPageInit();

      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "productlistcollectionselectedwebscreen_818753_value",
          "string"
        ),
        1,
        ReactSystemFunctions.convertToTypeByName("current", "string"),
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  ProductListCollectionSelectedWebScreenComponent_791652_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "productAttribute02"
        ),
        "string"
      ),
      ProductAttribute02Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistcollectionselectedwebscreen_791825_value",
          "productAttribute02Description"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListCollectionSelectedWebScreen/ProductListCollectionSelectedWebScreenComponent_791652_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BRemoveFavorite = result?.data.b2BRemoveFavorite;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListCollectionSelectedWebScreenComponent_791652_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListCollectionSelectedWebScreenComponent_791652_onClick1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      await this.ProductListCollectionSelectedWebScreenPageInit();

      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "productlistcollectionselectedwebscreen_818753_value",
          "string"
        ),
        1,
        ReactSystemFunctions.convertToTypeByName("current", "string"),
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  ProductListCollectionSelectedWebScreenComponent_818753_onChange =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }
      KuikaAppManager.increaseServerRequestCount();

      let localVar = {
        PageNumber_0: ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            ReactSystemFunctions.value(
              this,
              "productlistcollectionselectedwebscreen_818753_value",
              "current",
              "",
              "",
              ""
            )
          ),
          "number"
        ),
        UserId_0: ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            stateVars.B2BGetUserId !== undefined
              ? stateVars.B2BGetUserId?.length > 0
                ? stateVars.B2BGetUserId[0].id
                : null
              : this.state.B2BGetUserId?.length > 0
              ? this.state.B2BGetUserId[0].id
              : null
          ),
          "Guid"
        ),
        filtre_0: ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            ReactSystemFunctions.value(
              this,
              "productlistcollectionselectedwebscreen_810087_value",
              "value",
              "",
              "",
              ""
            )
          ),
          "string"
        ),
        PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
      };

      KuikaAppManager.showSpinner(this);

      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ProductListCollectionSelectedWebScreen/ProductListCollectionSelectedWebScreenComponent_818753_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.B2BListProductCollectionSelected =
        result?.data.b2BListProductCollectionSelected;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductListCollectionSelectedWebScreenComponent_818753_onChange1_();
          resolve();
        });
      });

      KuikaAppManager.hideSpinner(this);
      return isErrorOccurred;
    };
  ProductListCollectionSelectedWebScreenComponent_818753_onChange1_ =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }

      stateVars.dataSource_791825 =
        stateVars.B2BListProductCollectionSelected ??
        this.state.B2BListProductCollectionSelected;
      formVars.productlistcollectionselectedwebscreen_818753_total =
        ReactSystemFunctions.value(
          this,
          stateVars.B2BListProductCollectionSelected !== undefined
            ? stateVars.B2BListProductCollectionSelected?.length > 0
              ? stateVars.B2BListProductCollectionSelected[0].totalRowCount
              : null
            : this.state.B2BListProductCollectionSelected?.length > 0
            ? this.state.B2BListProductCollectionSelected[0].totalRowCount
            : null
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProductListCollectionSelectedWebScreenPageInit();
    }
  }
}
